export default __webpack_public_path__ + "static/indexExchange-339db805097ea082f61c1fe09760133e.svg";